<template ref="SpiderChartReport">
  <Loader v-if="showLoader" />
</template>

<script>
import html2canvas from "html2canvas";
import Loader from "../../components/common/Loader.vue";
import moment from "moment";
import apiCalls from "../api/apiCalls";
import api from "../constants/api";
export default {
  name: "SpiderChartReport",
  data() {
    return {
      download: false,
      showLoader: false
    };
  },
  created() {
    if (this.download) {
      this.pdfmake("");
    }
  },
  components: {
    Loader
  },
  methods: {
    pdfMakeCall(callFrom, length) {
      console.log(callFrom, length);
      switch (callFrom) {
        case "spider":
          this.downloadPdfSpiderChart(length);
          break;
        case "oee":
        case "machine-assessment":
        case "pillar-assessment":
        case "monthly-assessment":
        case "yearly-assessment":
        case "kpi":
          this.downloadPdfMachineReport(callFrom, length);
          break;
        case "globalgapClosure":
        case "plantgapClosure":
        case "plantWiseGapClosure":
        case "notSustained":
        case "pillargapClosure":
        case "machineReplication":
          this.downloadPdfMaturityReport(callFrom, length);
          break;
        default:
          break;
      }
    },
    pdfMakeAndEmail(callFrom, length) {
      this.downloadPdfMaturityReport(callFrom, length, true);
    },
    async downloadPdfSpiderChart(length) {
      this.showLoader = true;
      const pageWidth = 600;
      const pageHeight = 600;
      let docDefinition = {
        pageSize: "A4",
        // [left, top, right, bottom]
        pageMargins: [20, 65, 20, 35],
        pageOrientation: "portrait",
        content: []
      };
      let filename = "Spiderweb View";
      docDefinition.header = await this.addPdfMakeHeader(filename);
      docDefinition.footer = this.addPdfMakeFooter();
      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        let pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      for (let i = 0; i <= length; i++) {
        await html2canvas(document.getElementById(`each-chart${i}`), {
          logging: true,
          letterRendering: true,
          allowTaint: false,
          useCORS: true,
          scale: 5, // (1920 * 2) / window.innerWidth,
          backgroundColor: null
        })
          .then((canvas) => {
            const comp = document.getElementById("each-chart" + i);
            let img = new Image();
            const ratio = comp.clientHeight / comp.clientWidth; // (pageWidth - 50) / comp.clientWidth
            const canvasWidth = (pageHeight * comp.clientWidth) / comp.clientHeight < pageWidth ? (pageHeight * comp.clientWidth) / comp.clientHeight : pageWidth;
            const canvasHeight = pageHeight;
            const marginX = (pageWidth - canvasWidth) / 2;
            const marginY = (pageHeight - canvasHeight) / 2;
            img.src = canvas.toDataURL("image/jpg");
            console.log(ratio, marginX, marginY);
            docDefinition.content.push({
              image: canvas.toDataURL("image/jpg"),
              height: canvasHeight,
              width: canvasWidth,
              positions: [
                {
                  horizontalRatio: 0,
                  left: 2,
                  pageInnerHeight: 450.28,
                  pageInnerWidth: 801.89,
                  pageNumber: 1,
                  pageOrientation: "portrait",
                  top: 70,
                  verticalRatio: 0.33312605489917385
                }
              ],
              x: 0,
              y: 240,
              alignment: "centre",
              margin: [0, 0, 0, 0]
            });
          })

          .catch((error) => {
            console.log("ERROR SAVING FESTIVAL IMAGE", error);
          });
      }

      setTimeout(() => {
        console.log("kkk");

        pdfMake.createPdf(docDefinition).download(filename + ".pdf");

        this.showLoader = false;
      }, 2000);
    },
    async addPdfMakeHeader(reportName) {
      let GoodyearSVG =
        '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 141 42" style="enable-background:new 0 0 141 42;" xml:space="preserve"><style type="text/css">.st0{fill:#FFE500;}.st1{enable-background:new    ;}.st2{fill:#FFFFFF;}.st3{fill:#0053BC;}</style><g id="Group_4347" transform="translate(9664 22725)"><circle id="Ellipse_182" class="st0" cx="-9643" cy="-22704" r="21"/><g class="st1"><path class="st2" d="M-9605.6-22716.8c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8c0,0.7-0.1,1.2-0.4,1.7c-0.3,0.5-0.7,0.9-1.2,1.2c-0.5,0.3-1.1,0.4-1.8,0.4h-2.6c-0.1,0-0.1,0-0.1,0.1v4.3c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-10.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h4.4C-9606.7-22717.2-9606.1-22717.1-9605.6-22716.8z M-9606.3-22712.6c0.3-0.3,0.5-0.7,0.5-1.3c0-0.5-0.2-1-0.5-1.3s-0.8-0.5-1.3-0.5h-2.4c-0.1,0-0.1,0-0.1,0.1v3.4c0,0.1,0,0.1,0.1,0.1h2.4C-9607.1-22712.1-9606.6-22712.2-9606.3-22712.6z"/><path class="st2" d="M-9602.4-22706.1c0,0-0.1-0.1-0.1-0.1v-10.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v10.8c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5C-9602.3-22706-9602.4-22706-9602.4-22706.1z"/><path class="st2" d="M-9593.8-22714c0.5,0.2,0.9,0.6,1.2,1c0.3,0.4,0.4,0.9,0.4,1.4v5.4c0,0.1,0,0.1-0.1,0.1s-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1s-0.1-0.1-0.1-0.1v-0.5c0,0,0-0.1,0-0.1s0,0-0.1,0c-0.5,0.6-1.3,0.9-2.3,0.9c-0.8,0-1.5-0.2-2-0.6c-0.5-0.4-0.8-1-0.8-1.8c0-0.8,0.3-1.5,0.9-1.9c0.6-0.5,1.4-0.7,2.5-0.7h1.7c0.1,0,0.1,0,0.1-0.1v-0.4c0-0.4-0.1-0.7-0.4-1c-0.2-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.4,0.3-0.5,0.6c0,0.1-0.1,0.2-0.2,0.2l-1.6-0.2c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1,0-0.1c0.1-0.7,0.4-1.2,1-1.6s1.4-0.6,2.3-0.6C-9594.9-22714.3-9594.3-22714.2-9593.8-22714z M-9594.6-22707.8c0.4-0.3,0.6-0.6,0.6-1.1v-0.8c0-0.1,0-0.1-0.1-0.1h-1.3c-0.6,0-1,0.1-1.3,0.3c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.8			c0.3,0.2,0.6,0.3,1,0.3C-9595.4-22707.3-9595-22707.5-9594.6-22707.8z"/><path class="st2" d="M-9584.3-22713.5c0.5,0.5,0.8,1.2,0.8,2.1v5.2c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-4.9c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.5-1.1-0.5s-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.2v4.9c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-7.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v0.5c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.4-0.6,1.1-0.9,2-0.9C-9585.5-22714.3-9584.8-22714-9584.3-22713.5z"/><path class="st2" d="M-9577.3-22712.7c0,0-0.1,0.1-0.1,0.1h-1.6c-0.1,0-0.1,0-0.1,0.1v3.9c0,0.4,0.1,0.7,0.3,0.9s0.5,0.3,0.8,0.3h0.5c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v1.2c0,0.1-0.1,0.2-0.2,0.2l-0.8,0c-0.8,0-1.5-0.1-1.9-0.4c-0.4-0.3-0.6-0.8-0.6-1.6v-4.6c0-0.1,0-0.1-0.1-0.1h-0.9c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-1.1c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h0.9c0.1,0,0.1,0,0.1-0.1v-1.9c0-0.1,0-0.1,0.1-0.1s0.1-0.1,0.1-0.1h1.4c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v1.9c0,0.1,0,0.1,0.1,0.1h1.6c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v1.1C-9577.3-22712.8-9577.3-22712.8-9577.3-22712.7z"/></g><g class="st1"><path class="st2" d="M-9610.2-22691.3c-0.6-0.3-1.1-0.8-1.4-1.4s-0.5-1.3-0.5-2.1v-3.6c0-0.8,0.2-1.4,0.5-2c0.3-0.6,0.8-1.1,1.4-1.4c0.6-0.3,1.3-0.5,2.1-0.5c0.8,0,1.5,0.2,2.1,0.5c0.6,0.3,1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2v3.6c0,0.8-0.2,1.5-0.5,2.1c-0.3,0.6-0.8,1.1-1.4,1.4c-0.6,0.3-1.3,0.5-2.1,0.5C-9608.8-22690.8-9609.5-22691-9610.2-22691.3zM-9606.4-22693.1c0.4-0.4,0.6-1,0.6-1.6v-3.7c0-0.7-0.2-1.2-0.6-1.7c-0.4-0.4-0.9-0.6-1.6-0.6c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.7v3.7c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.6,1.6,0.6C-9607.4-22692.4-9606.8-22692.6-9606.4-22693.1z"/><path class="st2" d="M-9594.9-22695.1c0,0.8-0.1,1.4-0.3,2c-0.2,0.7-0.6,1.3-1.1,1.6c-0.5,0.4-1.2,0.6-2,0.6c-0.8,0-1.4-0.3-1.8-0.8c0,0,0,0-0.1,0c0,0,0,0,0,0.1v3.5c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-10.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v0.5c0,0,0,0.1,0,0.1s0,0,0.1,0c0.5-0.6,1.1-0.8,1.8-0.8c0.8,0,1.4,0.2,1.9,0.6s0.9,0.9,1.1,1.6C-9595-22696.5-9594.9-22695.9-9594.9-22695.1z M-9596.7-22695.1c0-0.8-0.1-1.4-0.4-1.8c-0.3-0.5-0.8-0.8-1.4-0.8c-0.6,0-1,0.3-1.2,0.8c-0.2,0.4-0.4,1-0.4,1.9c0,0.8,0.1,1.5,0.4,1.9c0.3,0.5,0.7,0.7,1.2,0.7c0.6,0,1-0.2,1.3-0.7C-9596.9-22693.6-9596.7-22694.3-9596.7-22695.1z"/><path class="st2" d="M-9588.8-22697.7c0,0-0.1,0.1-0.1,0.1h-1.6c-0.1,0-0.1,0-0.1,0.1v3.9c0,0.4,0.1,0.7,0.3,0.9s0.5,0.3,0.8,0.3h0.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v1.2c0,0.1-0.1,0.2-0.2,0.2l-0.8,0c-0.8,0-1.5-0.1-1.9-0.4c-0.4-0.3-0.6-0.8-0.6-1.6v-4.6c0-0.1,0-0.1-0.1-0.1h-0.9c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-1.1c0-0.1,0-0.1,0.1-0.1s0.1-0.1,0.1-0.1h0.9c0.1,0,0.1,0,0.1-0.1v-1.9c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.4c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v1.9c0,0.1,0,0.1,0.1,0.1h1.6c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v1.1C-9588.7-22697.8-9588.7-22697.8-9588.8-22697.7z"/><path class="st2" d="M-9586.8-22700.6c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.5,0.3,0.8s-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3S-9586.6-22700.4-9586.8-22700.6z M-9586.9-22691.1c0,0-0.1-0.1-0.1-0.1v-7.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v7.8c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5C-9586.8-22691-9586.9-22691-9586.9-22691.1z"/><path class="st2" d="M-9572.3-22698.6c0.5,0.5,0.7,1.2,0.7,2.1v5.3c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-4.9c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1-0.4s-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.2v4.9c0,0.1,0,0.1-0.1,0.1s-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-4.9c0-0.5-0.1-0.9-0.4-1.2s-0.6-0.4-1.1-0.4c-0.4,0-0.7,0.1-1,0.4c-0.3,0.2-0.4,0.6-0.5,1v5.2c0,0.1,0,0.1-0.1,0.1s-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-7.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v0.5c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0.2-0.3,0.5-0.5,0.9-0.7s0.7-0.2,1.2-0.2c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0,0,0.1,0,0.1,0c0.2-0.4,0.6-0.7,1-0.9c0.4-0.2,0.9-0.3,1.4-0.3C-9573.4-22699.3-9572.8-22699.1-9572.3-22698.6z"/>' +
        '		<path class="st2" d="M-9569.5-22700.6c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3' +
        "			c0.2,0.2,0.3,0.5,0.3,0.8s-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3S-9569.3-22700.4-9569.5-22700.6z M-9569.6-22691.1" +
        "			c0,0-0.1-0.1-0.1-0.1v-7.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v7.8" +
        '			c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5C-9569.5-22691-9569.5-22691-9569.6-22691.1z"/>' +
        '		<path class="st2" d="M-9566.1-22691.1c0,0-0.1-0.1-0.1-0.1v-1.4c0-0.1,0-0.2,0.1-0.2l3.9-4.6c0.1-0.1,0-0.1,0-0.1h-3.7' +
        "			c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-1.3c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h5.8c0.1,0,0.1,0,0.1,0.1" +
        "			s0.1,0.1,0.1,0.1v1.4c0,0.1,0,0.2-0.1,0.2l-4,4.6c0,0.1,0,0.1,0,0.1h3.9c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v1.3" +
        '			c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-6C-9566.1-22691-9566.1-22691-9566.1-22691.1z"/>' +
        '		<path class="st2" d="M-9553.5-22699c0.5,0.2,0.9,0.6,1.2,1c0.3,0.4,0.4,0.9,0.4,1.4v5.4c0,0.1,0,0.1-0.1,0.1s-0.1,0.1-0.1,0.1' +
        "			h-1.5c-0.1,0-0.1,0-0.1-0.1s-0.1-0.1-0.1-0.1v-0.5c0,0,0-0.1,0-0.1s0,0-0.1,0c-0.5,0.6-1.3,0.9-2.3,0.9c-0.8,0-1.5-0.2-2-0.6" +
        "			c-0.5-0.4-0.8-1-0.8-1.8c0-0.8,0.3-1.5,0.9-1.9c0.6-0.5,1.4-0.7,2.5-0.7h1.7c0.1,0,0.1,0,0.1-0.1v-0.4c0-0.4-0.1-0.7-0.4-1" +
        "			c-0.2-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.4,0.3-0.5,0.6c0,0.1-0.1,0.2-0.2,0.2l-1.6-0.2c-0.1,0-0.1,0-0.1-0.1" +
        "			c0,0-0.1-0.1,0-0.1c0.1-0.7,0.4-1.2,1-1.6s1.4-0.6,2.3-0.6C-9554.6-22699.3-9554-22699.2-9553.5-22699z M-9554.3-22692.8" +
        "			c0.4-0.3,0.6-0.6,0.6-1.1v-0.8c0-0.1,0-0.1-0.1-0.1h-1.3c-0.6,0-1,0.1-1.3,0.3c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.8" +
        '			c0.3,0.2,0.6,0.3,1,0.3C-9555.1-22692.3-9554.7-22692.5-9554.3-22692.8z"/>' +
        '		<path class="st2" d="M-9545.9-22697.7c0,0-0.1,0.1-0.1,0.1h-1.6c-0.1,0-0.1,0-0.1,0.1v3.9c0,0.4,0.1,0.7,0.3,0.9s0.5,0.3,0.8,0.3' +
        "			h0.5c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v1.2c0,0.1-0.1,0.2-0.2,0.2l-0.8,0c-0.8,0-1.5-0.1-1.9-0.4c-0.4-0.3-0.6-0.8-0.6-1.6" +
        "			v-4.6c0-0.1,0-0.1-0.1-0.1h-0.9c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-1.1c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h0.9" +
        "			c0.1,0,0.1,0,0.1-0.1v-1.9c0-0.1,0-0.1,0.1-0.1s0.1-0.1,0.1-0.1h1.4c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v1.9c0,0.1,0,0.1,0.1,0.1" +
        '			h1.6c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v1.1C-9545.8-22697.8-9545.8-22697.8-9545.9-22697.7z"/>' +
        '		<path class="st2" d="M-9543.9-22700.6c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3' +
        "			c0.2,0.2,0.3,0.5,0.3,0.8s-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3S-9543.7-22700.4-9543.9-22700.6z M-9544-22691.1" +
        "			c0,0-0.1-0.1-0.1-0.1v-7.8c0-0.1,0-0.1,0.1-0.1s0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1s0.1,0.1,0.1,0.1v7.8c0,0.1,0,0.1-0.1,0.1" +
        '			s-0.1,0.1-0.1,0.1h-1.5C-9543.9-22691-9544-22691-9544-22691.1z"/>' +
        '		<path class="st2" d="M-9538.8-22691.5c-0.6-0.4-1-1-1.3-1.8c-0.2-0.6-0.3-1.2-0.3-1.8c0-0.7,0.1-1.3,0.3-1.8' +
        "			c0.2-0.7,0.7-1.3,1.3-1.7c0.6-0.4,1.3-0.6,2.2-0.6c0.8,0,1.5,0.2,2.1,0.6s1,1,1.3,1.7c0.2,0.5,0.3,1.1,0.3,1.8" +
        "			c0,0.7-0.1,1.3-0.3,1.8c-0.2,0.8-0.7,1.4-1.3,1.8c-0.6,0.4-1.3,0.6-2.1,0.6C-9537.5-22690.9-9538.2-22691.1-9538.8-22691.5z" +
        "			 M-9535.6-22692.8c0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0.2-0.8,0.2-1.3c0-0.6-0.1-1-0.2-1.3c-0.1-0.4-0.3-0.7-0.6-0.9" +
        "			c-0.3-0.2-0.6-0.3-1.1-0.3c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4-0.2,0.8-0.2,1.3c0,0.5,0.1,1,0.2,1.3" +
        '			c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.2,0.6,0.3,1.1,0.3C-9536.2-22692.5-9535.9-22692.6-9535.6-22692.8z"/>' +
        '		<path class="st2" d="M-9525.2-22698.5c0.5,0.5,0.8,1.2,0.8,2.1v5.2c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5' +
        "			c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-4.9c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.5-1.1-0.5s-0.8,0.1-1.1,0.4" +
        "			c-0.3,0.3-0.4,0.7-0.4,1.2v4.9c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.5c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1v-7.8" +
        "			c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.5c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v0.5c0,0,0,0.1,0,0.1c0,0,0,0,0,0" +
        '			c0.4-0.6,1.1-0.9,2-0.9C-9526.4-22699.3-9525.7-22699-9525.2-22698.5z"/>' +
        "	</g>" +
        '	<path id="Path_5291" class="st3" d="M-9646.8-22694.6c-1.8,1.7-4.1,3-5,3c-0.2,0-0.5-0.2-0.5-0.4c0,0,0,0,0,0c0-1.9,2-2.8,2.8-4.3' +
        "		c0.6-1.4,1.1-2.9,1.6-4.3c0.5-1.6,1.2-3.1,2.2-4.5c1,2,2.3,4.3,3.2,6.3C-9643.7-22697.7-9645.3-22696.1-9646.8-22694.6" +
        "		 M-9634.6-22703.9c0.2,0.2,0.4,0.5,0.4,0.8c-6.6,3.3-10.1,10.7-17,13.1c-0.2-0.3-0.3-0.6-0.4-0.9" +
        "		C-9645-22693.2-9641.6-22700.7-9634.6-22703.9 M-9647.5-22712.8c2.1-1.4,4.3-2.6,6.6-3.7c-0.2,0.7-0.2,1.3-0.3,2" +
        "		c0,0.5,0.1,1.1,0.3,1.5l-4.9,2.8C-9646.5-22711-9647-22711.9-9647.5-22712.8 M-9645.4-22706.8c0-0.6,0.1-1.2,0.1-1.8" +
        "		c0-0.2,0-0.5,0-0.7c1.3,0,2.6,0.1,3.9,0.3v0.2C-9642.7-22708-9644-22707.3-9645.4-22706.8 M-9640.4-22708.1c0.4,1.1,1.1,2.1,2,3" +
        "		c1-0.3,1.1-1.4,2-1.8l1.5,2.4c-2.5,1.4-4.8,3.2-6.9,5.1c-1.2-2.1-2.3-4.1-3.2-6.1C-9643.5-22706.6-9642-22707.4-9640.4-22708.1" +
        "		 M-9640.6-22712.2h0.3l-0.2,2.3c-0.3,0-0.7,0.1-1,0c-0.8,0-1.6,0-2.7-0.1L-9640.6-22712.2z M-9617.9-22719.8c0,2.9-4,3.7-6.8,3.7" +
        "		c-1.4,0-2.9-0.1-4.3-0.2v0.2l1.3,0.5c0,1-1.6,0.8-2.4,1.2c0.2,0.2,0.5,0.1,0.5,0.3v0.1c-0.5,0.6-1.3,0.9-2.1,0.8" +
        "		c-0.5,0-1-0.1-1.5-0.3l-0.2,0.2v0.5c0,0.5-0.1,2.3-0.7,2.3c-0.3,0-0.5-0.3-0.8-0.4c-0.2,0.6-0.1,1.5-0.6,2c-0.4,0-0.7-0.5-1.1-0.7" +
        "		c-0.4,1-0.8,2-1.5,2.9c-1.4-0.2-1.6-2.4-1.6-3.8c0-0.5,0.1-1.1,0.2-1.6c-0.6-0.8-0.9-1.8-0.9-2.8c0-3.6,3.9-4.7,6.6-4.7" +
        "		c2.8,0,5.4,0.3,8.3,0.3c2.5,0,5-0.2,7.5-0.7L-9617.9-22719.8z M-9637.3-22712.6l-0.3-1.3l-1-0.1l0.1,0.2" +
        "		C-9637.8-22713.7-9637.9-22712.8-9637.3-22712.6 M-9632.5-22717.8c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0-0.7-0.2-1-0.2" +
        "		c-0.2,0-0.4,0.2-0.5,0.4c-0.4,0.4-1,0.3-1.5,0.4c-0.2,0.5-0.7,0.9-1.3,1c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1" +
        '		c0.4-0.4,0.9-0.6,1.4-0.5c0.7,0,0.6-0.8,1.1-0.8c0.1,0,0.1,0,0.2,0C-9632.9-22717.4-9632.5-22717.6-9632.5-22717.8"/>' +
        "</g>" +
        "</svg>";

      console.log("header");

      return (_currentPage, _pageCount) => {
        return {
          margin: [2, 2, 2, 0],
          stack: [
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      // font: "Barlow",
                      color: "white",
                      fillColor: "#1250B0",
                      alignment: "right",
                      columns: [
                        {
                          svg: GoodyearSVG,
                          alignment: "left",
                          width: "35%",
                          fit: [100, 50]
                        },
                        {
                          text: "" + reportName,
                          bold: true,
                          alignment: "left",
                          width: "45%",
                          fontSize: 11,
                          margin: [63, 14, 0, 0]
                        },
                        {
                          text: "" + moment(new Date()).format("DD-MMM-YYYY"),
                          bold: true,
                          alignment: "right",
                          fontSize: 11,
                          width: "20%",
                          margin: [63, 14, 0, 0]
                        }
                        // logoImage
                      ]
                    }
                  ]
                ]
              }
            }
          ]
        };
      };
    },
    async downloadPdfMachineReport(from, printData) {
      this.showLoader = true;
      const pageWidth = 800;
      const pageHeight = 500;
      let docDefinition = {
        pageSize: "A4",
        // [left, top, right, bottom]
        pageMargins: [20, 65, 20, 35],
        pageOrientation: "landscape",
        content: []
      };
      let filename = "";
      switch (from) {
        case "oee":
          filename = "Machine OEE Report";
          break;
        case "assessment":
          filename = "Machine Step Audit Report";
          break;
        case "kpi":
          filename = "Machine KPI Report";
          break;
        case "machine-assessment":
          filename = "Machine Step Audit Report (by Machine)";
          break;
        case "pillar-assessment":
          filename = "Machine Step Audit Report (by Pillar)";
          break;
        case "monthly-assessment":
          filename = "Machine Step Audit Report (Monthly Preview)";
          break;
        case "yearly-assessment":
          filename = "Machine Step Audit Report (Yearly Preview)";
          break;
        case "globalgapClosure":
          filename = "Gap Closure Report (Global)";
          break;
        case "plantgapClosure":
          filename = "Gap Closure Report (Plant)";
          break;
        case "pillargapClosure":
          filename = "Gap Closure Report (Pillar)";
          break;
        case "machineReplication":
          filename = "Machine Replication";
          break;
        case "plantWiseGapClosure":
          filename = "Gap Closure Monthly Report";
          break;
        case "notSustained":
          filename = "Not Sustained Report";
          break;
        default:
          filename = "Chart";
          break;
      }

      docDefinition.header = await this.addPdfMakeHeader(filename);
      docDefinition.footer = this.addPdfMakeFooter();

      console.log(docDefinition);

      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        let pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      console.time("chart");

      for (const element of printData) {
        await html2canvas(document.getElementById(element), {
          logging: true,
          letterRendering: true,
          allowTaint: false,
          useCORS: true,
          scale: 5, // (1920 * 2) / window.innerWidth,
          backgroundColor: null
        })
          .then((canvas) => {
            const comp = document.getElementById(element);
            let img = new Image();
            const ratio = comp.clientHeight / comp.clientWidth; // (pageWidth - 50) / comp.clientWidth
            const canvasWidth = (pageHeight * comp.clientWidth) / comp.clientHeight < pageWidth ? (pageHeight * comp.clientWidth) / comp.clientHeight : pageWidth;
            const canvasHeight = pageHeight;
            const marginX = (pageWidth - canvasWidth) / 2;
            const marginY = (pageHeight - canvasHeight) / 2;
            img.src = canvas.toDataURL("image/jpg");
            console.log("window.innerWidth " + window.innerWidth);
            console.log(canvasHeight, canvasWidth, comp.clientHeight, comp.clientWidth, ratio);
            console.log(marginX, marginY);
            docDefinition.content.push({
              image: canvas.toDataURL("image/jpg"),
              height: canvasHeight,
              width: canvasWidth,
              positions: [
                {
                  horizontalRatio: 0,
                  left: 2,
                  pageInnerHeight: 450.28,
                  pageInnerWidth: 801.89,
                  pageNumber: 1,
                  pageOrientation: "landscape",
                  top: 70,
                  verticalRatio: 0.33312605489917385
                }
              ],
              x: marginX,
              y: marginY,
              alignment: "centre",
              margin: [0, 0, 0, 0]
            });
          })
          .catch((error) => {
            console.log("ERROR SAVING FESTIVAL IMAGE", error);
          });
      }
      console.timeEnd("chart");
      setTimeout(() => {
        console.log("kkk");

        pdfMake.createPdf(docDefinition).download(filename + ".pdf");

        this.showLoader = false;
      }, 2000);
    },
    async downloadPdfMaturityReport(from, printData, needToMail = false) {
      this.showLoader = true;
      const pageWidth = 800;
      const pageHeight = 500;
      let docDefinition = {
        pageSize: "A4",
        // [left, top, right, bottom]
        pageMargins: [20, 65, 20, 35],
        pageOrientation: "landscape",
        content: []
      };
      let filename = "";
      switch (from) {
        case "oee":
          filename = "Machine OEE Report";
          break;
        case "assessment":
          filename = "Machine Step Audit Report";
          break;
        case "kpi":
          filename = "Machine KPI Report";
          break;
        case "machine-assessment":
          filename = "Machine Step Audit Report (by Machine)";
          break;
        case "pillar-assessment":
          filename = "Machine Step Audit Report (by Pillar)";
          break;
        case "monthly-assessment":
          filename = "Machine Step Audit Report (Monthly Preview)";
          break;
        case "yearly-assessment":
          filename = "Machine Step Audit Report (Yearly Preview)";
          break;
        case "globalgapClosure":
          filename = "Gap Closure Report (Global)";
          break;
        case "plantgapClosure":
          filename = "Gap Closure Report (Plant)";
          break;
        case "pillargapClosure":
          filename = "Gap Closure Report (Pillar)";
          break;
        case "machineReplication":
          filename = "Machine Replication";
          break;
        case "plantWiseGapClosure":
          filename = "Gap Closure Monthly Report";
          break;
        case "notSustained":
          filename = "Not Sustained Report";
          break;
        default:
          filename = "Chart";
          break;
      }

      docDefinition.header = await this.addPdfMakeHeader(filename);
      docDefinition.footer = this.addPdfMakeFooter();

      console.log(docDefinition);

      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        let pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      console.time("chart");

      for (const element of printData) {
        await html2canvas(document.getElementById(element), {
          logging: true,
          letterRendering: true,
          allowTaint: false,
          useCORS: true,
          scale: (1920 * 2) / window.innerWidth,
          backgroundColor: null
        })
          .then((canvas) => {
            const comp = document.getElementById(element);
            let img = new Image();
            const ratio = comp.clientHeight / comp.clientWidth; // (pageWidth - 50) / comp.clientWidth
            const canvasWidth = (pageHeight * comp.clientWidth) / comp.clientHeight < pageWidth ? (pageHeight * comp.clientWidth) / comp.clientHeight : pageWidth;
            const canvasHeight = (pageHeight * comp.clientWidth) / comp.clientHeight > pageWidth ? (pageWidth * comp.clientHeight) / comp.clientWidth : pageHeight;
            const marginX = (pageWidth - canvasWidth) / 2;
            const marginY = (pageHeight - canvasHeight) / 2;
            img.src = canvas.toDataURL("image/jpg");
            console.log("window.innerWidth " + window.innerWidth);
            console.log(canvasHeight, canvasWidth, comp.clientHeight, comp.clientWidth, ratio);
            console.log(marginX, marginY);
            docDefinition.content.push({
              image: canvas.toDataURL("image/jpg"),
              height: canvasHeight,
              width: canvasWidth,
              positions: [
                {
                  horizontalRatio: 0,
                  left: 2,
                  pageInnerHeight: 450.28,
                  pageInnerWidth: 801.89,
                  pageNumber: 1,
                  pageOrientation: "landscape",
                  top: 70,
                  verticalRatio: 0.33312605489917385
                }
              ],
              x: marginX,
              y: marginY,
              alignment: "centre",
              margin: [0, 0, 0, 0]
            });
          })
          .catch((error) => {
            console.log("ERROR SAVING FESTIVAL IMAGE", error);
          });
      }
      console.timeEnd("chart");
      setTimeout(() => {
        console.log("kkk");
        if (needToMail) {
          this.showLoader = true;
          pdfMake.createPdf(docDefinition).getBlob((blob) => {
            console.log(blob);
            const formData = new FormData();
            formData.append("file", blob);
            apiCalls.httpCallDetails(api.SENDMONTHLYREPORT, "post", formData).then((data) => {
              console.log(data);
            });
          });
        } else pdfMake.createPdf(docDefinition).download(filename + ".pdf");
        this.showLoader = false;
      }, 2000);
    },
    addPdfMakeFooter() {
      console.log("footer");
      let GoodyearSVG =
        '<svg xmlns="http://www.w3.org/2000/svg" width="98" height="38" viewBox="0 0 98 38"> <g id="Goodyear_Logo_38px" transform="translate(15433 3244)"> <rect id="Rectangle_1295" data-name="Rectangle 1295" width="98" height="38" transform="translate(-15433 -3244)" fill="#fff" opacity="0"/> <g id="Group_3470" data-name="Group 3470" transform="translate(-15431.754 -3234.719)"> <path id="Path_169" data-name="Path 169" d="M437.23,745.447a.246.246,0,0,1,.1.367l-.576.87c-.074.11-.16.159-.353.036a2.977,2.977,0,0,0-1.511-.432c-.685,0-1.325.2-1.457.686l-1.091,4.632c-.11.454.233.674.711.674h.294a.206.206,0,0,0,.221-.184l.625-2.659a.328.328,0,0,1,.306-.245h3.37a.2.2,0,0,1,.184.245l-.931,3.945a.353.353,0,0,1-.306.246h-4.791a3.217,3.217,0,0,1-3.284-3.5c0-3.578,2.745-5.306,5.992-5.306a4.916,4.916,0,0,1,2.5.624m11.335,3.149a5.043,5.043,0,0,1-5.293,5.22c-2.4,0-4.3-1.2-4.3-3.738a5.133,5.133,0,0,1,5.465-5.256c2.415,0,4.13,1.225,4.13,3.773m-3.554-1.569c.148-.6-.036-.883-.5-.883-.551,0-.7.245-.87.98l-1.066,4.473c-.134.576-.036.895.49.895s.7-.245.846-.846Zm14.018,1.569a5.043,5.043,0,0,1-5.293,5.22c-2.4,0-4.3-1.2-4.3-3.738a5.133,5.133,0,0,1,5.465-5.256c2.414,0,4.13,1.225,4.13,3.773m-3.554-1.569c.148-.6-.036-.883-.5-.883-.552,0-.7.246-.87.98l-1.066,4.473c-.135.576-.036.895.49.895s.7-.245.846-.846ZM466.134,745a3.052,3.052,0,0,1,3.356,3.248c0,2.683-1.789,5.378-4.89,5.378h-5.28a.2.2,0,0,1-.184-.245l1.924-8.136c.049-.184.122-.245.307-.245Zm-.269,2.022c.135-.576-.037-.673-.907-.673a.229.229,0,0,0-.245.184l-1.312,5.526c-.036.159.013.22.135.22.795,0,1.091,0,1.225-.551Zm5.123,7.524a6.032,6.032,0,0,1-2.7,1.6.24.24,0,0,1-.246-.258c0-1,1.1-1.519,1.532-2.341a20.488,20.488,0,0,0,.845-2.34,8.92,8.92,0,0,1,1.164-2.438c.539,1.054,1.225,2.327,1.728,3.393-.686.7-1.494,1.581-2.328,2.377m6.568-4.987a.644.644,0,0,1,.233.442c-3.566,1.752-5.452,5.759-9.128,7.066a1.333,1.333,0,0,1-.233-.478c3.553-1.262,5.367-5.318,9.128-7.033m-6.96-4.816a38.927,38.927,0,0,1,3.541-2.009A4.517,4.517,0,0,0,474,743.82a2.12,2.12,0,0,0,.135.833l-2.65,1.519a16.665,16.665,0,0,1-.9-1.433M471.754,748c.025-.319.062-.625.062-.943a2.045,2.045,0,0,0-.025-.38,18.46,18.46,0,0,1,2.1.171v.1A14.391,14.391,0,0,1,471.753,748m2.672-.736a4.4,4.4,0,0,0,1.054,1.606c.514-.16.6-.772,1.054-.993l.82,1.274a22.112,22.112,0,0,0-3.688,2.732c-.637-1.148-1.213-2.208-1.728-3.308a19.43,19.43,0,0,1,2.488-1.312m-.123-2.181h.148l-.1,1.237a4.189,4.189,0,0,1-.564.025c-.429,0-.87-.025-1.458-.073Zm12.216-4.092c0,1.544-2.132,1.985-3.639,1.985-.76,0-1.555-.074-2.291-.11v.1l.686.269c-.025.514-.845.442-1.287.624.088.11.283.037.283.172v.037a1.463,1.463,0,0,1-1.127.454,2.069,2.069,0,0,1-.809-.16l-.088.088v.294c0,.245-.062,1.25-.353,1.25-.172,0-.282-.148-.442-.233-.123.33-.073.795-.33,1.078-.22,0-.392-.294-.587-.367a6.715,6.715,0,0,1-.785,1.569c-.735-.123-.883-1.312-.883-2.031a4.212,4.212,0,0,1,.088-.87,2.769,2.769,0,0,1-.5-1.495c0-1.96,2.1-2.549,3.578-2.549s2.928.185,4.46.185a21.71,21.71,0,0,0,4.031-.367Zm-10.439,3.86-.147-.686-.539-.049.061.1c.38.036.306.539.625.637m2.61-2.781a.617.617,0,0,1-.2.037c-.184,0-.38-.11-.53-.11a.318.318,0,0,0-.269.2c-.208.2-.539.171-.795.208a.846.846,0,0,1-.7.53.983.983,0,0,0,.442.109.617.617,0,0,0,.246-.049.854.854,0,0,1,.747-.265c.393,0,.344-.442.613-.442a.618.618,0,0,1,.109.025c.123-.037.331-.123.331-.233m2.168,7.818-1.458-4.644c-.049-.159.012-.245.171-.245h3.59a.329.329,0,0,1,.319.245l.833,2.683,2.156-2.683a.572.572,0,0,1,.454-.245h1.714c.147,0,.172.088.037.245l-3.871,4.694-.821,3.445a.353.353,0,0,1-.306.245h-3.468a.2.2,0,0,1-.184-.245ZM496.271,745a.2.2,0,0,1,.184.245l-.24,1.041a.353.353,0,0,1-.306.246H493.3a.353.353,0,0,0-.294.245l-.353,1.495c-.012.1.036.147.147.147h1.6a.2.2,0,0,1,.184.246l-.232,1.041a.353.353,0,0,1-.306.245h-1.59a.209.209,0,0,0-.22.134l-.442,1.826c-.025.123.011.185.134.185h2.659a.2.2,0,0,1,.184.246l-.245,1.04a.353.353,0,0,1-.306.246h-6.555a.2.2,0,0,1-.185-.246l1.924-8.136c.049-.184.123-.245.306-.245Zm8.308,8.381a.233.233,0,0,1-.221.245h-3.37a.26.26,0,0,1-.269-.246l-.1-.919a.187.187,0,0,0-.208-.184H497.8a.334.334,0,0,0-.294.184l-.563.919a.467.467,0,0,1-.392.246H495.3c-.123,0-.171-.123-.1-.246l4.938-8.16a.436.436,0,0,1,.391-.246h2.915a.259.259,0,0,1,.269.246Zm-4.386-2.65c.123,0,.184-.061.171-.184l-.22-2.144c-.012-.11-.1-.123-.172,0l-1.262,2.144c-.073.123-.049.184.074.184ZM512.96,745c2.34,0,3.1,1.116,3.1,2.353a3.673,3.673,0,0,1-1.678,3.136.258.258,0,0,0-.135.319l.563,2.561c.025.135-.025.258-.184.258h-3.6a.3.3,0,0,1-.294-.246l-.453-2.1c-.025-.123-.05-.221-.171-.221h-.123c-.122,0-.208.061-.245.233l-.49,2.083a.353.353,0,0,1-.306.246h-3.467a.2.2,0,0,1-.185-.246l1.924-8.136c.049-.184.122-.245.306-.245Zm-.943,2.022c.134-.576-.036-.673-.907-.673a.229.229,0,0,0-.246.184l-.7,2.965c-.036.159.012.221.134.221.795,0,1.078,0,1.213-.551Zm4.395,5.078a.768.768,0,1,1-.547.225.772.772,0,0,1,.547-.225m0,1.372a.6.6,0,1,0-.6-.6.6.6,0,0,0,.6.6m.123-.539.232.38h-.184l-.208-.367h-.1v.367H516.1v-.859h.318c.159,0,.33.037.33.233a.24.24,0,0,1-.22.245m-.1-.123c.088,0,.147-.012.147-.123,0-.049-.012-.1-.147-.1h-.159v.22Z" transform="translate(-428.738 -740.914)" fill="#ffe600"/> <path id="Path_170" data-name="Path 170" d="M516.168,765.182a1.606,1.606,0,0,1,1.684-1.124c.948,0,1.254.5,1.087,1.124l-.6,2.261a1.6,1.6,0,0,1-1.684,1.124c-.948,0-1.254-.5-1.086-1.124Zm.306,2.242c-.088.329-.008.486.353.486a.548.548,0,0,0,.605-.486l.6-2.224c.088-.328.007-.487-.353-.487a.548.548,0,0,0-.605.487Z" transform="translate(-459.829 -749.205)" fill="#fff"/> <path id="Path_171" data-name="Path 171" d="M520.832,768.542,522,764.154h2.523l-.177.656h-1.619l-.3,1.131h1.21l-.177.655H522.25l-.518,1.943Z" transform="translate(-461.73 -749.24)" fill="#fff"/> <path id="Path_172" data-name="Path 172" d="M525.876,768.542l1.167-4.388h2.524l-.177.656h-1.619l-.3,1.131h1.21l-.177.655H527.3l-.518,1.943Z" transform="translate(-463.537 -749.24)" fill="#fff"/> <path id="Path_173" data-name="Path 173" d="M531.295,768.567l.153-.559h1.787l-.154.559Z" transform="translate(-465.478 -750.621)" fill="#fff"/> <path id="Path_174" data-name="Path 174" d="M536.512,764.813h-.874l.177-.656h2.655l-.177.656h-.874l-.992,3.732h-.9Z" transform="translate(-466.992 -749.24)" fill="#fff"/> <path id="Path_175" data-name="Path 175" d="M539.121,768.542l1.167-4.388h.9l-.474,1.787h.963l.474-1.787h.905l-1.167,4.388h-.9l.518-1.943h-.962l-.518,1.943Z" transform="translate(-468.282 -749.24)" fill="#fff"/> <path id="Path_176" data-name="Path 176" d="M544.8,768.542l1.167-4.388h2.422l-.177.656H546.7l-.3,1.131h1.167l-.177.655H546.22l-.344,1.289H547.5l-.177.656Z" transform="translate(-470.316 -749.24)" fill="#fff"/> <path id="Path_177" data-name="Path 177" d="M550.222,768.567l.153-.559h1.787l-.153.559Z" transform="translate(-472.258 -750.621)" fill="#fff"/> <path id="Path_178" data-name="Path 178" d="M554.533,768.542h-.905l1.167-4.388h1.268c1.014,0,1.438.359,1.189,1.294a1.456,1.456,0,0,1-.933,1.107l.24,1.987h-.919l-.161-1.818c-.117.012-.306.019-.467.019Zm.641-2.419h.321a.746.746,0,0,0,.853-.675c.139-.523-.007-.675-.5-.675h-.321Z" transform="translate(-473.478 -749.24)" fill="#fff"/> <path id="Path_179" data-name="Path 179" d="M560.325,765.182a1.6,1.6,0,0,1,1.684-1.125c.948,0,1.255.5,1.086,1.125l-.6,2.261a1.6,1.6,0,0,1-1.683,1.124c-.949,0-1.255-.5-1.088-1.124Zm.306,2.242c-.088.329-.007.486.353.486a.548.548,0,0,0,.605-.486l.6-2.224c.088-.328.008-.487-.353-.487a.549.549,0,0,0-.607.487Z" transform="translate(-475.648 -749.205)" fill="#fff"/> <path id="Path_180" data-name="Path 180" d="M565.318,768.542h-.874l2.137-4.388H567.7l-.2,4.388h-.876l.1-.972h-.992Zm.722-1.629h.729l.147-1.884H566.9Z" transform="translate(-477.353 -749.24)" fill="#fff"/> <path id="Path_181" data-name="Path 181" d="M571.2,764.154h1.343c.934,0,1.32.426,1.078,1.325l-.466,1.739a1.654,1.654,0,0,1-1.78,1.325h-1.342Zm-.1,3.768h.314a.7.7,0,0,0,.809-.614l.511-1.921c.124-.461-.008-.613-.489-.613h-.314Z" transform="translate(-479.356 -749.24)" fill="#fff"/> <rect id="Rectangle_516" data-name="Rectangle 516" width="94.507" height="19.364" transform="translate(0 -0.001)" fill="none"/> </g> </g> </svg>';

      let footerText = "©" + new Date().getFullYear() + " The Goodyear Tire & Rubber Company ";
      return (currentPage, pageCount) => {
        // you can apply any logic and return any valid pdfmake element
        return {
          margin: [2, 0, 2, 0],
          border: [false, false, false, false],
          table: {
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  fontSize: 9,
                  color: "white",
                  fillColor: "#1250B0",
                  alignment: "left",
                  columns: [
                    {
                      svg: GoodyearSVG,
                      fit: [40, 23],
                      width: "30%",
                      margin: [0, 2, 0, 2],
                      alignment: "left"
                    },
                    {
                      text: footerText,
                      alignment: "center",
                      width: "40%",
                      margin: [0, 2, 0, 0],
                      bold: true
                    },
                    {
                      text: "PAGE " + currentPage.toString() + "/" + pageCount.toString(),
                      alignment: "right",
                      width: "30%",
                      margin: [0, 2, 0, 0],
                      fontWeight: 400
                    }
                  ]
                }
              ]
            ]
          }
        };
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
